"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateAction = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactHotLoader = require("react-hot-loader");

var _blocks = require("@bueno/blocks");

var Elements = _interopRequireWildcard(require("../ActionModal.styles"));

var _CreateActionForm = require("./components/CreateActionForm");

var _actionCreators = require("../../../redux/modules/action/actionCreators");

var _hooks = require("../../../utils/hooks");

var _LoadingOverlay = require("../components/LoadingOverlay");

var _utils = require("./utils");

var _useAxiosSwr = require("../../../utils/useAxiosSwr");

function mapStateToProps({
  auth,
  betaAction,
  userSites,
  betaSelections
}) {
  var _auth$user$portfolio$, _auth$user$portfolio;

  const sites = betaSelections.selectedSites.reduce((acc, siteId) => {
    if (userSites.sites[siteId] !== undefined) {
      acc[siteId] = userSites.sites[siteId];
    }

    return acc;
  }, {});
  return {
    isPending: betaAction.isPending,
    organisations: Object.values((_auth$user$portfolio$ = (_auth$user$portfolio = auth.user.portfolio) === null || _auth$user$portfolio === void 0 ? void 0 : _auth$user$portfolio.projects) !== null && _auth$user$portfolio$ !== void 0 ? _auth$user$portfolio$ : {}),
    userId: auth.user.forgeId,
    sites
  };
}

const mapDispatchToProps = {
  requestSave: _actionCreators.addAction
};

const CreateAction = ({
  isOpen,
  onRequestClose,
  requestSave,
  isPending,
  sites,
  userId,
  organisations
}) => {
  const [site, setSite] = React.useState((0, _utils.sortByLabel)(Object.values(sites))[0]);
  const [validForm, setValidForm] = React.useState(false);
  const [pristine, setPristine] = React.useState(true);
  const formRef = React.useRef(null);
  const wasPending = (0, _hooks.usePrevious)(isPending); // If selected sites changes, ensure prefilled site is still within selected sites

  React.useEffect(() => {
    // tslint:disable-next-line: strict-type-predicates
    if (sites[site.syncoId] === undefined) {
      setSite((0, _utils.sortByLabel)(Object.values(sites))[0]);
    }
  }, [sites]);
  const siteOptions = React.useMemo(() => {
    const options = Object.values(sites).map(s => ({
      label: s.label,
      value: s.syncoId
    }));
    return (0, _utils.sortByLabel)(options);
  }, [sites]);

  const handleSiteChange = siteId => {
    setSite(sites[siteId]);
  };

  const handleCreateAction = () => {
    const createActionForm = formRef.current;

    if (createActionForm !== null) {
      createActionForm.dispatchEvent(new Event('submit', {
        cancelable: true,
        bubbles: true
      }));
    }
  };
  /**
   * If form has been changed, confirm before discarding changes.
   */


  const handleClose = React.useCallback(function handleClose() {
    let shouldClose = true;

    if (!pristine) {
      shouldClose = window.confirm('You have unsaved changes that will be lost.');
    }

    if (shouldClose) {
      onRequestClose();
    }
  }, [pristine]); // Handle finding the assignee and site IDs before submitting

  const [projectKey, siteLabel] = site.id.split('~');
  const {
    data: assigneeData
  } = (0, _useAxiosSwr.useHashtagUsernameList)(projectKey, siteLabel);

  const onSubmit = values => {
    var _assigneeData$find$au, _assigneeData$find, _organisations$find;

    const payload = { ...values,
      // Support hydra action creation
      siteId: site.forgeId,
      assigneeId: (_assigneeData$find$au = assigneeData === null || assigneeData === void 0 ? void 0 : (_assigneeData$find = assigneeData.find(assignee => assignee.display === values.assignee)) === null || _assigneeData$find === void 0 ? void 0 : _assigneeData$find.authId) !== null && _assigneeData$find$au !== void 0 ? _assigneeData$find$au : null,
      // Support attachments, these are stripped in serialiseCreateAction
      userId,
      attachment: values.screenshot,
      organisationId: (_organisations$find = organisations.find(organisation => site.projectId === organisation.project_pk)) === null || _organisations$find === void 0 ? void 0 : _organisations$find.forge_id
    };
    if (validForm) requestSave(payload, []);
  };

  React.useEffect(() => {
    if (wasPending && !isPending) {
      onRequestClose();
    }
  }, [isPending]);
  return /*#__PURE__*/React.createElement(Elements.Modal, {
    title: /*#__PURE__*/React.createElement(Elements.Title, null, /*#__PURE__*/React.createElement(_react.Trans, {
      id: "action_form.add_action"
    })),
    isOpen: isOpen,
    onRequestClose: handleClose,
    width: 600
  }, /*#__PURE__*/React.createElement(Elements.ModalContent, {
    isPending: isPending
  }, isPending && /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingOverlay, null), /*#__PURE__*/React.createElement(Elements.SingleColumnLayout, null, /*#__PURE__*/React.createElement(Elements.SingleCol, null, /*#__PURE__*/React.createElement(_CreateActionForm.CreateActionForm, {
    projectKey: projectKey,
    formRef: formRef,
    onSubmit: onSubmit,
    setValidForm: setValidForm,
    setPristine: setPristine,
    site: site,
    sites: sites,
    siteOptions: siteOptions,
    onSiteChange: handleSiteChange,
    defaultSummary: "",
    defaultContext: ""
  })))), /*#__PURE__*/React.createElement(_blocks.ModalFooter, null, /*#__PURE__*/React.createElement(_blocks.ControlGroup, {
    tight: true
  }, /*#__PURE__*/React.createElement(_blocks.Button, {
    appearance: "plain",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "action_form.cancel"
  })), /*#__PURE__*/React.createElement(_blocks.Button, {
    appearance: "solid",
    primary: true,
    onClick: handleCreateAction,
    disabled: isPending,
    className: "AddAction--Submit"
  }, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "action_form.add_action"
  })))));
};

const connected = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateAction));
exports.CreateAction = connected;